import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { AccountService } from '@app/teacher/services/account.service';
import { takeUntil } from 'rxjs/operators';
import { StudentAccount, Transaction, TransactionOperation } from '@df/interfaces';
import { Subject } from 'rxjs';
import { REWARD_BANK_TYPES } from '@app/app.constants';

@Component({
    selector: 'app-account-transactions',
    templateUrl: './account-transactions.component.html',
    styleUrls: ['./account-transactions.component.scss']
})
export class AccountTransactionsComponent implements OnInit, OnChanges {
    public transactions: Transaction[] = [];
    public operation = TransactionOperation;
    public pages: number[] = [];
    public hasNext: boolean;
    public hasPrev: boolean;
    public currentPage: number = 1;
    totalPages: number;

    @Input() account: StudentAccount;
    @Input() reward_active = REWARD_BANK_TYPES.DRAHMA;

    private $destroy = new Subject<boolean>();

    constructor(private accountService: AccountService) {}

    public ngOnInit(): void {}

    public ngOnChanges(): void {
        this.updateTransactionList();
    }

    private updateTransactionList(): void {
        if (this.account) {
            const userId = this.account.student
                ? this.account.student.user.id
                : this.account.profile
                ? this.account.profile.user.id
                : null;
            // console.log(this.account);
            if (this.reward_active === REWARD_BANK_TYPES.DRAHMA) {
                this.accountService
                    .getTransactions(this.account.id, this.currentPage)
                    .pipe(takeUntil(this.$destroy))
                    .subscribe((resultSet: any) => {
                        // console.log(resultSet);
                        this.initPaginator(resultSet);
                    });
            } else {
                if (!userId) {
                    return;
                }
                this.accountService
                    .getNewTransactions(userId, this.currentPage, this.reward_active)
                    .pipe(takeUntil(this.$destroy))
                    .subscribe((resultSet: any) => {
                        // console.log(resultSet);
                        this.initPaginator(resultSet);
                    });
            }
        }
    }

    private initPaginator(resultSet: {
        next: string;
        previous: string;
        count: number;
        page: number;
        pages_count: number;
        results: Transaction[];
    }) {
        this.transactions = resultSet.results;
        this.hasNext = !!resultSet.next;
        this.hasPrev = !!resultSet.previous;
        this.currentPage = resultSet.page;
        this.totalPages = resultSet.pages_count;
        this.pages = [];
        if (resultSet.results.length > 10) {
            for (let i = 1; i <= resultSet.pages_count; i++) {
                this.pages.push(i);
            }
        }
    }

    public changePage(page: string) {
        if (page === 'next') {
            if (this.hasNext) {
                this.currentPage++;
                this.updateTransactionList();
            }
        } else if (page === 'prev') {
            if (this.hasPrev) {
                this.currentPage--;
                this.updateTransactionList();
            }
        } else {
            if (this.currentPage !== +page) {
                this.currentPage = Number(page);
                this.updateTransactionList();
            }
        }
    }
}
